import { SET_DATA_ALERTS } from './actiontypes';
import { fetchDataAlerts, createDataAlert, updateDataAlert, removeAlert } from '../../api/Api';

// only the fields defiend on NewBuildingAlert are user-writable
const ALERT_WRITABLE_FIELDS = [
  'name',
  'buildings',
  'equipment',
  'percent_threshold',
  'enabled',
  'alert_initial_interval',
  'alert_realert_interval',
  'alert_clear_interval',
  'alert_emails',
];

const fields = (fieldNames) => (dataObj) =>
  fieldNames.reduce((o, f) => {
    // eslint-disable-next-line no-param-reassign
    o[f] = dataObj[f];
    return o;
  }, {});

const alertFields = fields(ALERT_WRITABLE_FIELDS);

export const fetchDataAlertsAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return fetchDataAlerts(jwt).then((data) => dispatch({ type: SET_DATA_ALERTS, data }));
};

export const createAlertAC = (alert) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return createDataAlert(jwt, alertFields(alert)).then(() => dispatch(fetchDataAlertsAction()));
};

export const updateAlertAC = (alertId, alert) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return updateDataAlert(jwt, alertId, alertFields(alert)).then(() =>
    dispatch(fetchDataAlertsAction())
  );
};

export const removeAlertAC = (alertId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return removeAlert(jwt, alertId).then(() => dispatch(fetchDataAlertsAction()));
};
